module.exports = __webpack_public_path__ + "img/minus.aa107613.svg";